import * as React from 'react'
import { Grid } from '@mui/material'
import Textfield from '../FormsUI/Textfield'
import DateTimePicker from '../FormsUI/DateTimePicker'
import Select from '../FormsUI/Select'
import AutocompletePseudonym from '../Autocomplete/Pseudonym'
import AutocompleteGroupSpecie from '../Autocomplete/FamilySpecie'
import AutocompleteGroupSite from '../Autocomplete/SiteSeccionAcronym'
import _ from 'lodash'

const ItemsContainer = ({ x, s, m, align, editable, variant = 'standard', ...props }) => {
  let child = null

  const TYPE_AUTOCOMPLET_SPECIE = ['family_', 'specie_']
  const TYPE_AUTOCOMPLET_SITE = ['site_', 'section_', 'siteAcronym_']
  const TYPE_AUTOCOMPLET_PSEUDONYM = ['pseudonym_']
  const TYPE_COORDINATES = ['longX', 'latY']

  const isCoordinateField = _.includes(TYPE_COORDINATES, props.name)

  const otherPropsControl = {
    InputProps: {
      readOnly: isCoordinateField ? false : !editable,
    },
    variant: variant,
    disabled: props.disabled ?? false,

    ...(isCoordinateField && {
      type: 'number',
      inputProps: {
        step: 'any',
        min: props.name === 'longX' ? -180 : -90,
        max: props.name === 'longX' ? 180 : 90,
      },
      ...(!props.error && {
        helperText: 'Ubicación exacta con botón',
      }),
      placeholder: props.name === 'longX' ? 'Ingrese longitud' : 'Ingrese latitud',
    }),
  }

  const isSpecieGroup = _.includes(TYPE_AUTOCOMPLET_SPECIE, props.name)
  const isSiteGroup = _.includes(TYPE_AUTOCOMPLET_SITE, props.name)
  const isPseudonym = _.includes(TYPE_AUTOCOMPLET_PSEUDONYM, props.name)

  if (isPseudonym)
    child = <AutocompletePseudonym {...props} editable={editable} variant={variant} />

  if (isSpecieGroup) child = <AutocompleteGroupSpecie {...props} editable={editable} />

  if (isSiteGroup) child = <AutocompleteGroupSite {...props} editable={editable} />

  if (props.options && !isSpecieGroup && !isSiteGroup && !isPseudonym)
    child = <Select {...props} {...otherPropsControl} />

  if (props.date)
    child = (
      <DateTimePicker
        {...props}
        {...otherPropsControl}
        InputProps={{ readOnly: true }}
        disabled
      />
    )

  return (
    <Grid item xs={x} sm={s} md={m} sx={{ textAlignLast: align }}>
      {child ?? <Textfield {...props} {...otherPropsControl} />}
    </Grid>
  )
}

export default React.memo(ItemsContainer)
